export default __webpack_public_path__ + "static/a1-a518a75bdcc38a9fb8f234bbb5c165df.jpg";